import { registerBundle } from '@/lib/i18n';

import { bookingStringsGu } from './strings.gu';
import { bookingStringsHi } from './strings.hi';
import { bookingStringsMr } from './strings.mr';

/** The `booking` i18n namespace (BP-04 §6), registered by the feature that owns it. */
export const BOOKING_NAMESPACE = 'booking';

export const bookingStrings = {
  landing: {
    title: 'Book an appointment',
    lead: 'Pick your services, choose a time, and we will hold the chair for you.',
    start: 'Book now',
    mine: 'My bookings',
  },
  steps: {
    services: 'Services',
    technician: 'Technician',
    slot: 'Time',
    verify: 'Your number',
    confirm: 'Confirm',
  },
  services: {
    title: 'What would you like?',
    none: 'Nothing is bookable online just now',
    addons: 'Add-ons',
    duration: '{{minutes}} min',
    running: '{{minutes}} min · ₹{{amount}}',
    next: 'Choose a technician',
    pickOne: 'Pick at least one service',
  },
  technician: {
    title: 'Who would you like?',
    any: 'Anyone available',
    anyHint: 'The earliest free chair',
    next: 'Choose a time',
    none: 'Nobody is taking bookings online just now',
  },
  slot: {
    title: 'When suits you?',
    none: 'Nothing free that day',
    suggestion: 'The next free day is {{date}}',
    next: 'Continue',
  },
  verify: {
    title: 'Your mobile number',
    phone: 'Mobile number',
    phoneHint: 'We send a one-time code by WhatsApp.',
    phoneInvalid: 'That does not look like an Indian mobile number.',
    send: 'Send the code',
    resend: 'Send it again',
    resendIn: 'You can ask again in {{seconds}}s',
    code: 'One-time code',
    verify: 'Verify',
    consent: 'Send me appointment reminders on WhatsApp',
    consentHint: 'You can turn this off at any time.',
    notice: 'How we use your information',
    invalid: 'That code did not match. Please try again.',
    exhausted: 'Too many attempts. Please ask for a new code.',
  },
  confirm: {
    title: 'Confirm your booking',
    summary: 'Your appointment',
    total: 'Total',
    book: 'Confirm',
    taken: 'That time has just gone. Please pick another.',
    policy:
      'You can change or cancel this booking online until {{hours}} hours before it starts. After that, please call the salon.',
  },
  detail: {
    title: 'Booking {{ref}}',
    when: 'When',
    status: 'Status',
    reschedule: 'Change the time',
    cancel: 'Cancel this booking',
    cancelTitle: 'Cancel booking {{ref}}?',
    cancelReason: 'Tell us why (optional)',
    cancelConfirm: 'Yes, cancel it',
    cancelKeep: 'Keep it',
    locked: 'This booking can no longer be changed online. Please call the salon.',
    pickNew: 'Pick a new time',
    keep: 'Keep the current time',
    moved: 'Your booking has been moved.',
    cancelled: 'Your booking has been cancelled.',
  },
  waitlist: {
    offer: 'That time is taken. Shall we tell you if it frees up?',
    join: 'Tell me if it frees',
    joined: 'We will message you the moment it does.',
    failed: 'We could not add you just now. Please try again.',
  },
  mine: {
    title: 'My bookings',
    none: 'You have no upcoming bookings',
    open: 'Open',
  },
} as const;

/** Add the bundle, in every locale it has, to the shared instance. Idempotent. */
export function registerBookingStrings(): void {
  registerBundle(BOOKING_NAMESPACE, {
    en: bookingStrings,
    hi: bookingStringsHi,
    mr: bookingStringsMr,
    gu: bookingStringsGu,
  });
}

registerBookingStrings();
